import { render, staticRenderFns } from "./TextHeroSectionModule.vue?vue&type=template&id=6e5f0e73&"
import script from "./TextHeroSectionModule.vue?vue&type=script&lang=js&"
export * from "./TextHeroSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports